import { useState, useEffect, useRef } from 'react';

// ✅ UPDATED PORT TO 8392
const BRIDGE_URL = 'ws://100.119.212.17:8392/ws';

export const useWorldIndices = () => {
  const [indices, setIndices] = useState({});
  const [connectionStatus, setConnectionStatus] = useState('DISCONNECTED');
  const ws = useRef(null);

  useEffect(() => {
    // Prevent double connections in React Strict Mode
    if (ws.current) return;

    console.log(`🔌 Attempting connection to ${BRIDGE_URL}...`);
    ws.current = new WebSocket(BRIDGE_URL);

    ws.current.onopen = () => {
      console.log('✅ Connected to Go Bridge');
      setConnectionStatus('CONNECTED');
    };

    ws.current.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        
        // Update state map with new data, key by ID
        setIndices(prev => ({
          ...prev,
          [data.id]: {
              symbol: data.id,
              // Use fallback 0 to prevent NaN errors in UI
              price: data.price || 0,
              change: data.change || 0,
              changePercent: data.changePercent || 0,
              exchange: data.exchange,
              updatedAt: Date.now()
          }
        }));
      } catch (err) {
        console.error("Error parsing socket message:", err);
      }
    };

    ws.current.onclose = () => {
      console.log('❌ Socket Disconnected');
      setConnectionStatus('DISCONNECTED');
      ws.current = null;
    };

    return () => {
      if (ws.current) {
        ws.current.close();
        ws.current = null;
      }
    };
  }, []);

  // Convert map to array for easy rendering
  // Sort by symbol so they don't jump around
  const indicesArray = Object.values(indices).sort((a,b) => a.symbol.localeCompare(b.symbol));
  
  return { data: indicesArray, status: connectionStatus };
};